(function() {
    'use strict';
    function toggleSummary(panel, show) {
        const panelId = panel.dataset.panelId;
        const summary = document.getElementById(`nav-guide-summary-${panelId}`);
        const action = show ? 'add' : 'remove';
        summary.classList[action]('active');
    }

    const tabPanels = $('.js-nav-guide-tab-panel');

    tabPanels.each((i, el) => {
        $(el).on('show.bs.collapse', (ev) => {
            toggleSummary(ev.currentTarget, true);
        });
        $(el).on('hide.bs.collapse', (ev) => {
            toggleSummary(ev.currentTarget, false);
        });
    });

}());
